import React from 'react'
import {Button, Col, Form, Input, Row} from 'antd'
import '../styles/authPage/login.css'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import logo from '../static/images/New_logo.jpg'
import {Link} from 'react-router-dom/cjs/react-router-dom'
import apiRequest from '../hooks/ApiRequest'
import {getDecodedTokenData} from '../hooks/DecodeJWT'
toast.configure()

class Login extends React.Component {
  constructor() {
    super()
    this.state = {
      loggedIn: false,
      api: process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/login',
    }
  }
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.login(values)
      }
    })
  }

  // async login(data) {
  //   const response = await apiRequest(this.state.api, 'POST', data)
  //   const UserData = getDecodedTokenData(response?.data?.token)
  //   if (response.success) {
  //     toast.success(response.data.message, {
  //       position: toast.POSITION.TOP_CENTER,
  //       autoClose: 5000,
  //     })
  //     this.setState({loggedIn: true})
  //     localStorage.setItem('token', response?.data?.token)
  //     localStorage.setItem('user', JSON.stringify(UserData))
  //     localStorage.setItem('roles', JSON.stringify(UserData?.RoleName))
  //     localStorage.setItem('loggedInUserID', UserData?.UserId)
  //     localStorage.setItem('insurerId', UserData?.UserId)
  //     localStorage.setItem(
  //       'username',
  //       `${UserData?.FirstName} ${UserData?.LastName}`,
  //     )
  //     window.location.href = '/home'
  //   } else {
  //     toast.error(response.error, {
  //       position: toast.POSITION.TOP_CENTER,
  //       autoClose: 5000,
  //     })
  //   }
  // }
async login(data) {
  const response = await apiRequest(this.state.api, 'POST', data);
  const UserData = getDecodedTokenData(response?.data?.token);

  if (response.success) {
    const role = UserData?.RoleName;

    if (
      role === 'CLAIM_INITIATOR' ||
      role === 'CLAIMS_ASSESSOR' ||
      role === 'CLAIM_PROCESSOR' ||
      role === "CLAIMS_MANAGER" ||
      role === 'FINANCE_CLERK'
    ) {
      localStorage.setItem('token', response?.data?.token);
      const redirectURL = `https://outrisk-claim.kindlebit.com/login?token=${response?.data?.token}`;
      window.location.href = redirectURL;
      return; 
    }

    // Regular login flow for non-claim users
    toast.success(response.data.message, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
    });

    this.setState({ loggedIn: true });
    localStorage.setItem('token', response?.data?.token);
    localStorage.setItem('user', JSON.stringify(UserData));
    localStorage.setItem('roles', JSON.stringify(role));
    localStorage.setItem('loggedInUserID', UserData?.UserId);
    localStorage.setItem('insurerId', UserData?.UserId);
    localStorage.setItem('username', `${UserData?.FirstName} ${UserData?.LastName}`);

    window.location.href = '/home';
  } else {
    toast.error(response.error, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
    });
  }
}

  render() {
    const {getFieldDecorator} = this.props.form

    return (
      <div className="body-height">
        <div className="wrap-img">
          <img src={logo} style={{width: '400px', height: '150px'}} />
        </div>
        <div
          className="bg-white"
          style={{
            boxShadow: '0 0 16px grey',
            marginTop: '10px',
            borderRadius: '10px',
          }}>
          <Row>
            <Col md={12} sm={12} xs={24}>
              <div className="text-center  ">
                {/* <LayoutLogin /> */}
                <h2 className="h2-login">Sign in</h2>
                <Form onSubmit={this.handleSubmit} className="form-group-login">
                  <Form.Item>
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Email',
                        },
                      ],
                    })(<Input placeholder="E-mail" className="input-box" />)}
                  </Form.Item>
                  <Form.Item className="input-box">
                    {getFieldDecorator('password', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Password!',
                        },
                      ],
                    })(<Input.Password placeholder="Password" />)}
                  </Form.Item>
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      size="large"
                      className="btn-bg-primary">
                      LOG-IN
                    </Button>
                    <h6 className="login-h6">
                      <Link to="/forgot-password" className="underline-none">
                        Forgot Password
                      </Link>
                    </h6>
                  </Form.Item>
                </Form>
              </div>
            </Col>
            <Col md={12} sm={12} xs={24}>
              <div className="login-aside  flex items-center justify-center container">
                <div className=" text-center">
                  <h2 className="heading-aside-h2 ">Good Afternoon!</h2>
                  <h6 className="h6-login text-center">
                    Please sign-in into your account to get started
                  </h6>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

const WrappedNormalLoginForm = Form.create({name: 'normal_login'})(Login)

export default WrappedNormalLoginForm
